import { render, staticRenderFns } from "./member-list.vue?vue&type=template&id=30b963c0&scoped=true"
import script from "./member-list.vue?vue&type=script&lang=ts"
export * from "./member-list.vue?vue&type=script&lang=ts"
import style0 from "./member-list.vue?vue&type=style&index=0&id=30b963c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b963c0",
  null
  
)

export default component.exports